import styles from './ContinueCollection.module.css';

/**
 * "Continue your collection" — horizontal scroll of 3–4 onboarding-seeded titles.
 * Each card shows poster + title + "Earn Coin" CTA that navigates directly to the quiz.
 * Hidden when suggestions array is empty (caller is responsible for that guard).
 */
export default function ContinueCollection({ suggestions = [], onEarnCoin }) {
    if (!suggestions.length) return null;

    return (
        <section className={styles.section}>
            <h2 className={styles.title}>🎬 Continue Your Collection</h2>
            <div className={styles.track}>
                {suggestions.map((s, i) => {
                    const tmdbId = s.tmdbId ?? s.id;
                    const label  = s.title ?? s.name ?? 'Unknown';
                    return (
                        <article key={tmdbId ?? i} className={styles.card}>
                            <div className={styles.posterWrap} onClick={() => onEarnCoin?.(s)}>
                                {s.posterUrl
                                    ? <img src={s.posterUrl} alt={label} className={styles.poster} />
                                    : <div className={styles.posterFallback}>🎬</div>
                                }
                            </div>
                            <div className={styles.body}>
                                <p className={styles.cardTitle}>{label}</p>
                                <button className={styles.earnBtn} onClick={() => onEarnCoin?.(s)}>
                                    🪙 Earn Coin
                                </button>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
}